import { Button, MessageDialog } from 'Components/Core';
import { IconOpenInNewTab } from 'Lib/Icons';
import React from 'react';
import { Link as RLink } from 'react-router-dom';
import './Link.scss';

export interface ILinkProps {
  to?: any;
  openInNewTab?: boolean;
  content?: any;
  onClick?: any;
}

const Link: React.FC<React.PropsWithChildren<ILinkProps>> = ({
  to,
  openInNewTab = false,
  children,
  content,
  onClick,
}) => {
  children = children ?? content;

  return (
    <>
      {window.qest.isFrame ? (
        <MessageDialog
          messageTitle="Feature Unavailable"
          messageText="This feature is unavailable outside of the QEST Web App."
          alwaysEnabled
        >
          <Button subtle primary alwaysEnabled noPadding className="Link-Button">
            <span className="Link-Text">{children}</span>
          </Button>
        </MessageDialog>
      ) : (
        <RLink
          to={to}
          rel={openInNewTab ? 'noopener noreferrer' : undefined}
          target={openInNewTab ? '_blank' : undefined}
          onClick={onClick}
        >
          {children}
          {openInNewTab ? (
            <>
              {' '}
              <IconOpenInNewTab size={'0.8em'} />
            </>
          ) : undefined}
        </RLink>
      )}
    </>
  );
};

export { Link };
export default Link;
